'use client'

import React, { useCallback } from 'react'
import { useLocale, useTranslations } from 'next-intl'
import YouTubeIcon from '@mui/icons-material/YouTube'
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import LanguageIcon from '@mui/icons-material/Language'

import { useAppSelector } from '@/src/redux/store'
import { selectAuth } from '@/src/redux/slices/authSlice'
import { HomepageFooter } from './homepageFooter'

const HomepageFooterWrapper: React.FC = () => {
    const locale = useLocale()
    const t = useTranslations('footer')
    const user = useAppSelector(selectAuth)

    // Social media links configuration
    const socialMediaLinks = [
        {
            name: 'youtube',
            href: 'https://www.youtube.com/user/FlyinVideos',
            icon: YouTubeIcon
        },
        {
            name: 'twitter',
            href: 'https://twitter.com/flyincom',
            icon: 'twitter' // Custom SVG
        },
        {
            name: 'instagram',
            href: 'https://www.instagram.com/flyincom/',
            icon: InstagramIcon
        },
        {
            name: 'facebook',
            href: 'https://www.facebook.com/flyin.com',
            icon: FacebookIcon
        },
        {
            name: 'linkedin',
            href: 'https://www.linkedin.com/company/flyin-com',
            icon: LinkedInIcon
        },
        {
            name: 'threads',
            href: 'https://www.threads.net/@flyincom',
            icon: LanguageIcon
        }
    ]

    // Company links
    const companyLinks = [
        {
            label: t('aboutUs'),
            onClick: useCallback(() => {
                window.location.href = `/aboutUs.${locale}.html`
            }, [locale])
        },
        {
            label: t('faqs'),
            onClick: useCallback(() => {
                window.location.href = `/faqs.${locale}.html`
            }, [locale])
        },
        {
            label: t('privacyPolicy'),
            onClick: useCallback(() => {
                window.location.href = `/privacyPolicy.${locale}.html`
            }, [locale])
        },
        {
            label: t('termsOfUse'),
            onClick: useCallback(() => {
                window.location.href = `/termsOfUse.${locale}.html`
            }, [locale])
        },
        {
            label: t('careers'),
            onClick: useCallback(() => {
                window.location.href = `/careers.${locale}.html`
            }, [locale])
        }
    ]

    // Support links
    const supportLinks = [
        {
            label: t('flyinWallet'),
            onClick: useCallback(() => {
                window.location.href = `/accounts/wallet`
            }, [])
        },
        {
            label: t('contactUs'),
            onClick: useCallback(() => {
                window.location.href = `/contactUs.${locale}.html`
            }, [locale])
        },
        {
            label: t('addYourProperty'),
            onClick: useCallback(() => {
                window.location.href = `/addProperty.${locale}.html`
            }, [locale])
        },
        {
            label: t('fileClaim'),
            onClick: useCallback(() => {
                window.location.href = `/fileClaim.${locale}.html`
            }, [locale])
        }
    ]

    return (
        <HomepageFooter
            companyLinks={companyLinks}
            supportLinks={supportLinks}
            socialMediaLinks={socialMediaLinks}
            isSignedIn={user.signedIn}
        />
    )
}

export { HomepageFooterWrapper }
export default HomepageFooterWrapper
